module.exports = __webpack_public_path__ + "static/media/spinner-arrow.2cc57cd3.svg";